import React from 'react';

import IconFemtasy from 'components/IconFemtasy';
import PlayButton from 'components/PlayButton';

import ProgressBar from 'containers/StoryDetails/Player/ProgressBar';

import { usePlayer } from 'hooks/usePlayer';
import { useTracking } from 'hooks/useTracking';

import './style.scss';

const CourseFullPlayer = () => {
  const { trackContentInteraction } = useTracking();
  const {
    currentlyPlaying,
    isLoading,
    isPlaying,
    requestSeekBackward,
    requestSeekForward,
    togglePlay,
    fullAudioPlayed,
  } = usePlayer();

  const seekBackward = React.useCallback(() => {
    requestSeekBackward();
    trackContentInteraction(
      'seek_backward',
      'player',
      `story_${currentlyPlaying?.id}`,
      currentlyPlaying?.sourceUrl,
    );
  }, [currentlyPlaying, requestSeekBackward, trackContentInteraction]);

  const seekForward = React.useCallback(() => {
    requestSeekForward();
    trackContentInteraction(
      'seek_forward',
      'player',
      `story_${currentlyPlaying?.id}`,
      currentlyPlaying?.sourceUrl,
    );
  }, [currentlyPlaying, requestSeekForward, trackContentInteraction]);

  const togglePlayback = React.useCallback(() => {
    togglePlay();
    trackContentInteraction(
      isPlaying ? 'pause' : 'continue',
      'player',
      `story_${currentlyPlaying?.id}`,
      currentlyPlaying?.sourceUrl,
    );
  }, [currentlyPlaying, isPlaying, togglePlay, trackContentInteraction]);

  return (
    <div data-testid="course-player-controls" className="CourseFullPlayer">
      <div className="CourseFullPlayer__progressBar">
        <ProgressBar />
      </div>
      <div className="CourseFullPlayer__buttons">
        <button
          className="CourseFullPlayer__arrow CourseFullPlayer__arrow--rewind"
          onClick={seekBackward}
        >
          <IconFemtasy icon="15sec-bckwrds" size="40" />
        </button>
        <PlayButton
          size="64"
          alreadyListened={fullAudioPlayed}
          isPlaying={isPlaying}
          isLoading={isLoading}
          onClick={togglePlayback}
        />
        <button
          className="CourseFullPlayer__arrow Player__arrow--forward"
          onClick={seekForward}
        >
          <IconFemtasy icon="15sec-frwrds" size="40" />
        </button>
      </div>
    </div>
  );
};

export default CourseFullPlayer;
